/* eslint-disable react-hooks/exhaustive-deps */
import SearchIcon from "@mui/icons-material/Search";
import { SelectChangeEvent, Stack, Typography } from "@mui/material";
import { debounce } from "lodash";
import React from "react";
import { ControlledCustomSelect } from "../../../formsComponents";
import {
  CustomSearch,
  SearchIconWrapper,
  StyledInputBase,
} from "../../components/TableSearchBar/TableSearhBar";
import { ISearchPluginProps } from "./SerchPlugin.types";

export const SearchPlugin: React.FC<ISearchPluginProps> = (props) => {
  const {
    onChange,
    dropdownOptions,
    selectedDropdownValue,
    onDropdownChange,
    userType,
  } = props;
  const [search, setSearch] = React.useState("");

  const debounceFn = React.useCallback(debounce(handleDebounceFn, 800), []);

  function handleDebounceFn(inputValue: string) {
    onChange(inputValue);
  }
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    debounceFn(value);
    setSearch(value);
  };

  React.useEffect(() => {
    return () => {
      debounceFn.cancel();
    };
  }, []);

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={{ xs: 0.5, md: 2 }}
      width="100%"
      flexWrap="nowrap"
    >
      <ControlledCustomSelect
        label="Search by"
        value={selectedDropdownValue}
        placeholder="Select One"
        displayEmpty
        multiple
        options={dropdownOptions}
        onChange={(e: SelectChangeEvent<unknown>) =>
          onDropdownChange(e.target.value as string[])
        }
      />
      <CustomSearch
        sx={{
          width: "auto !important",
          flex: 1,
          ml: { xs: 0.5, md: 1 },
          "& .MuiInputBase-input": {
            width: "100% !important",
            minWidth: "250px",
            fontSize: { xs: "13px", md: "1rem" },
            paddingLeft: (theme) => `calc(1em + ${theme.spacing(3)})`,
          },
          "& .MuiBox-root": {
            padding: (theme) => theme.spacing(0, 1),
          },
        }}
      >
        <SearchIconWrapper sx={{ padding: { xs: "0 8px", md: "0 16px" } }}>
          <SearchIcon color="disabled" fontSize="small" />
        </SearchIconWrapper>
        <StyledInputBase
          value={search}
          placeholder="Search…"
          inputProps={{ "aria-label": "search" }}
          onChange={handleChange}
        />
      </CustomSearch>
    </Stack>
  );
};
